import { ARCHIVED_BOOLEAN_FILTERS } from '@/common/api/archivedTableFilters';
import type { FiltersSearchType } from '@/common/api/types/itemFilters';

export const OPEN_POSITION_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
  'teamId',
] as const satisfies readonly (keyof FiltersSearchType)[];

export const OPEN_POSITION_BOOLEAN_FILTERS = [...ARCHIVED_BOOLEAN_FILTERS] as const;

export const OPEN_POSITION_FILTER_KEYS = [
  ...OPEN_POSITION_PICKLIST_FILTERS,
  ...OPEN_POSITION_BOOLEAN_FILTERS,
] as const;
export type OpenPositionFilterKey = (typeof OPEN_POSITION_FILTER_KEYS)[number];
